import { useLayoutEffect, useState, type RefObject } from 'react';

/** Tracks plot container width — useLayoutEffect + remeasureKey so Firefox/Safari get width after mount. */
export function usePlotContainerWidth(
  ref: RefObject<HTMLElement | null>,
  enabled = true,
  remeasureKey: unknown = 0,
): number {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!enabled) {
      setWidth(0);
      return;
    }

    const el = ref.current;
    if (!el) return;

    const measure = () => {
      const w = Math.round(el.getBoundingClientRect().width);
      if (w > 0) {
        setWidth(prev => (prev === w ? prev : w));
      }
    };

    measure();

    let ro: ResizeObserver | undefined;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(measure);
      ro.observe(el);
    }
    window.addEventListener('resize', measure);

    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [enabled, ref, remeasureKey]);

  return width;
}
